import { ProductEffects } from './product.effects';
// import { ProfileClientEffects } from './profile-client.effects';
import { ProfileQuestionsEffects } from './profile-questions.effects';

export const EffectsAarray: any[] = [ProductEffects, ProfileQuestionsEffects];
